const INITIAL_STATE = {
  list: [],
  tipos: [],
  categorias: [],
  opcoes: { controladores: [], grupos_fisicos: [], tipos: [], categorias: [], estoque_itens: [], ordens_abertas: [] },
  selected: null,
  historico: [],
  fases: [],
  paginaAtual: 0,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'INVENTARIO_FETCHED':
      return { ...state, list: action.payload.data };
    case 'INVENTARIO_OPCOES_FETCHED':
      return { ...state, opcoes: action.payload.data };
    case 'INVENTARIO_TIPOS_FETCHED':
      return { ...state, tipos: action.payload.data };
    case 'INVENTARIO_CATEGORIAS_FETCHED':
      return { ...state, categorias: action.payload.data };
    case 'INVENTARIO_PAGE':
      return { ...state, paginaAtual: action.payload };
    case 'INVENTARIO_SELECTED':
      return { ...state, selected: action.payload };
    case 'INVENTARIO_HISTORICO_FETCHED':
      return { ...state, historico: action.payload.data };
    case 'INVENTARIO_FASES_FETCHED':
      return { ...state, fases: action.payload.data };
    default:
      return state;
  }
};
